import { render, staticRenderFns } from "./SignRecord.vue?vue&type=template&id=6bcc3ed7"
import script from "./SignRecord.vue?vue&type=script&lang=js"
export * from "./SignRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports